import axios from "axios";
import constants from "../constants";

const {
  GET_SELECTED_PRODUCTS, GET_SELECTED_PRODUCTS_SUCCESS, GET_SELECTED_PRODUCTS_ERROR,
  ADD_SELECTED_PRODUCT, ADD_SELECTED_PRODUCT_SUCCESS, ADD_SELECTED_PRODUCT_ERROR,
  DELETE_SELECTED_PRODUCT, DELETE_SELECTED_PRODUCT_SUCCESS, DELETE_SELECTED_PRODUCT_ERROR,
  EDIT_SELECTED_PRODUCT, EDIT_SELECTED_PRODUCT_SUCCESS, EDIT_SELECTED_PRODUCT_ERROR
} = constants;

const ADD_SELECTED_PRODUCT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/createProduct";
const GET_SELECTED_PRODUCTS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/getSelectedProducts";
const DELETE_SELECTED_PRODUCT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/deleteSelectedProduct";
const EDIT_SELECTED_PRODUCT_API_END_POINT = process.env.REACT_APP_API_URL + "/api/admin/updateSelectedProduct";


export const getSelectedProductsAction = (config) => async (dispatch) => {
  dispatch({ type: GET_SELECTED_PRODUCTS })
  await axios.get(GET_SELECTED_PRODUCTS_API_END_POINT, config)
    .then((res) => dispatch({ type: GET_SELECTED_PRODUCTS_SUCCESS, selectedProducts: res?.data?.selectedProducts }))
    .catch((error) => dispatch({ type: GET_SELECTED_PRODUCTS_ERROR, error }))
}

export const addSelectedProductAction = (data, config, callback1, callback2) => async (dispatch) => {
  dispatch({ type: ADD_SELECTED_PRODUCT })
  await axios.post(ADD_SELECTED_PRODUCT_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: ADD_SELECTED_PRODUCT_SUCCESS, message: res?.data?.message })
      callback1();
      callback2();
    })
    .catch((error) => dispatch({ type: ADD_SELECTED_PRODUCT_ERROR, error }))
}

export const deleteSelectedProductAction = (data, config, callback) => async (dispatch) => {
  dispatch({ type: DELETE_SELECTED_PRODUCT })
  await axios.post(DELETE_SELECTED_PRODUCT_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: DELETE_SELECTED_PRODUCT_SUCCESS, message: res?.data?.message })
      callback();
    })
    .catch((error) => dispatch({ type: DELETE_SELECTED_PRODUCT_ERROR, error }))
}

export const editSelectedProductAction = (data, config, callback1, callback2) => async (dispatch) => {
  dispatch({ type: EDIT_SELECTED_PRODUCT })
  await axios.post(EDIT_SELECTED_PRODUCT_API_END_POINT, data, config)
    .then((res) => {
      dispatch({ type: EDIT_SELECTED_PRODUCT_SUCCESS, message: res?.data?.message })
      callback1();
      callback2?.();
    })
    .catch((error) => {
			console.log('log: editSelectedProductAction -> error ->', error)
      dispatch({ type: EDIT_SELECTED_PRODUCT_ERROR, error })
    })
}
